import { render, staticRenderFns } from "./ScreenData.vue?vue&type=template&id=701058a8&scoped=true&"
import script from "./ScreenData.vue?vue&type=script&lang=js&"
export * from "./ScreenData.vue?vue&type=script&lang=js&"
import style0 from "./ScreenData.vue?vue&type=style&index=0&id=701058a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701058a8",
  null
  
)

export default component.exports